import RemoteSelect from "common/components/RemoteSelect/RemoteSelect";
import { User } from "types/User";

const processOptions = (options: User[]) =>
  options.map(({ id, email }) => ({
    value: id,
    label: email,
  }));

function UserSelect(props: any) {
  return (
    <RemoteSelect url="users" processOptions={processOptions} {...props} />
  );
}

export default UserSelect;
